// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cr-4";
export var closeButton = "_cr-6";
export var dismissButton = "_cr-3";
export var editImageWithAiContainer = "_cr-8";
export var imageUploadWrapper = "_cr-7";
export var misspelledWord = "_cr-5";
export var spellCheckContainer = "_cr-2";
export var spin = "_cr-1";
export var spinning = "_cr-0";